class ForecastRestAdapter {
  constructor ({ agaveAdapter }) {
    this.adapter = agaveAdapter
  }

  async get (locationId, program, { sku } = {}) {
    return this.adapter.get('forecast', { locationId, program, sku })
  }

  async list ({ locationIds, program, sku } = {}) {
    return this.adapter.get('forecast/list', { locationIds, program, sku })
  }
}

module.exports = ForecastRestAdapter
